import { Inject, Renderer2, OnInit, ViewChild, Directive } from '@angular/core';
import { CurrencyPipe, DOCUMENT } from '@angular/common';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { MediaService } from 'src/app/service/media/media.service';
import { DialogService } from 'src/app/service/dialog/dialog.service';
import { ToolPermissionsService } from 'src/app/service/auth/tool-permissions.service';

@Directive()
export class ToolFormComponent implements OnInit {
  @ViewChild('toolModelForm') public toolModelForm: NgForm;

  public maintenanceData: any = {
    required: false,
    date: null,
    file: '',
  };
  public inspectionData: any = {
    required: false,
    date: null,
    file: '',
  };

  public dataModel: any = {};
  public payloadModel: any = {};
  public dialogRecord: any = {};
  public data: any = {};

  public models: Array<any> = [];
  public employees: Array<any> = [];
  public vendors: Array<any> = [];

  public currentTabId: string;
  public tabs: Array<any> = [];
  public formattedValue: any = {};
  public currentPath: string;
  public pageType: string;
  public dataType: string;
  key: string;
  public submitted: boolean = false;
  public assetClass: string;

  constructor(
    dataType: string,
    @Inject(DOCUMENT) public _document,
    public renderer2: Renderer2,
    public location: Location,
    public currencyPipe: CurrencyPipe,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public toolsService: ToolsService,
    public toastService: ToastService,
    public mediaService: MediaService,
    public dialogService: DialogService,
    public toolPermissionsService: ToolPermissionsService,
  ) {
    this.dataType = dataType;
  }

  ngOnInit(): void {
    this.initTabs();
    this.setCurrentPathAndPageType();
  }

  isAllowed(resource1: string, action: string) {
    return this.toolPermissionsService.isAllowed(this.data, resource1, action);
  }

  navigateBack() {
    this.location.back();
  }

  initDialog() {
    this.dialogRecord.actionType = 'delete';
    this.dialogRecord.actionName = 'Delete';
    this.dialogRecord.name = 'document';
  }

  initTabs() {
    this.currentTabId = 'general';
    this.addTab('general', 'General Info');
  }

  addTab(id: string, label: string) {
    this.tabs.push({ id, label });
  }

  setCurrentPathAndPageType() {
    this.activatedRoute.url.subscribe(url => {
      this.currentPath = url[0].path;
      const urlPath = this.router.url.split('/');
      this.pageType = this.dataType === 'tools' ? urlPath[2] : urlPath[3];
    });
  }

  loadDatePicker(className: string = null, altField: string = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';

    if (className) {
      s.text = `loadDatePicker('` + className + `','` + altField + `');`;
    } else {
      s.text = `loadDatePicker()`;
    }
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  updatePromise(payload, redirectBack: boolean = true) {
    return new Promise((resolve, reject) => {
      this.toolsService.update[this.dataType]({ id: this.dataModel.id, data: payload }).subscribe(
        res => {
          this.toastService.showToast(res.message, 'success');
          resolve(res);
        },
        _ => {
          reject(false);
        },
      );
    });
  }

  update(payload, redirectBack: boolean = true) {
    this.toolsService.update[this.dataType]({ id: this.dataModel.id, data: payload }).subscribe(
      res => {
        this.toastService.showToast(res.message, 'success');
        if (redirectBack) this.navigateBack();
      },
      error => {
        error.error.errors.forEach(error => {
          console.error(error);
        });
      },
    );
  }

  handleUploadAttachment(payload: any) {
    const { data, key } = payload;
    this.dataType === 'tools'
      ? (this.payloadModel[key] = [...this.payloadModel[key], ...data])
      : (this.dataModel[key] = [...this.dataModel[key], ...data]);
  }

  handleDelete(id: number, key: string) {
    this.dialogRecord.actionType = 'delete';
    this.dialogRecord.actionName = 'Delete';
    this.dialogRecord.name = key === 'thumbnail' ? 'image' : 'document';
    const dialogId = this.dataType === 'tools' ? 'delete-dialog' : 'delete-model-dialog';

    this.dialogService.open(dialogId).then(res => {
      if (!res) {
        return this.initDialog();
      }

      this.mediaService.delete['models'](id).subscribe(
        () => {
          this.initDialog();
          const nestedKey = this.dataType === 'tools' ? 'model' : '';

          this.handleDeleteAttachment({ id, key }, nestedKey);
        },
        error => {
          console.error(error);
        },
      );
    });
  }

  handleDeleteAttachment(payload: any, nestedKey = '') {
    const { id, key } = payload;
    const isTools = this.dataType === 'tools';
    const obj = isTools ? this.payloadModel : this.dataModel;

    if (nestedKey) {
      this.dataModel[nestedKey][key] = this.dataModel[nestedKey][key].filter(attachment => attachment.id !== id);
      return;
    }

    if (key === 'thumbnail' || key === 'maintenance' || key === 'inspection') {
      obj[key] = [];
      return;
    }

    obj[key] = obj[key].filter(attachment => attachment.id !== id);
  }

  handleTabClick(id: string) {
    this.currentTabId = id;
  }

  removeCurrencyData(data: object) {
    return parseFloat(data.toString().replace(/\$|,/g, ''));
  }

  formatToCurrency(property: string, event: unknown = null) {
    if (event) {
      this.payloadModel[property] = this.removeCurrencyData(this.formattedValue[property]);
    }
    if (this.payloadModel[property]) {
      this.formattedValue[property] = this.currencyPipe.transform(
        parseFloat(this.payloadModel[property].toString()),
        '$ ',
      );
      return;
    }

    this.formattedValue[property] = '';
  }

  getUploadParentId(shouldUseModelId: boolean): number {
    if (shouldUseModelId) return this.dataModel?.model?.id;
    return this.dataModel.id;
  }

  handleUploadThumbnail(event: any, source: string, parentType: string, shouldUseModelId = false) {
    if (!event?.target?.files) return;

    const formData: FormData = new FormData();

    const parentId = this.getUploadParentId(shouldUseModelId).toString();

    formData.append('parentId', parentId);
    formData.append('parentType', parentType);
    for (let i = 0; i < event.target.files.length; i++) {
      formData.append('files', event.target.files[i]);
    }
    formData.append('category', this.getCategoryFromSource(source));

    this.mediaService.create['models'](formData).subscribe(
      res => {
        const data = source === 'thumbnail' ? res.data[0] : res.data;
        const isModelSource = this.dataType === 'tools' && ['maintenance', 'inspection'].includes(source);
        const sourceKey = isModelSource ? `model.${source}` : source;

        if (isModelSource) {
          this.dataModel.model[source] = [...this.dataModel.model[source], ...data];
          return;
        }

        this.setDataModel(sourceKey, data);
      },
      error => {
        console.error(error);
      },
    );
  }

  getCategoryFromSource(source: string): string {
    const arr = ['inspection', 'maintenance', 'thumbnail'];
    return arr.includes(source) ? source : '';
  }

  setPayload(field: string, value: unknown) {
    this.payloadModel[field] = value;
  }

  setDataModel(field: string, value: unknown) {
    this.dataModel[field] = value;
  }

  getPayload() {
    this.payloadModel.status = 'Published';
    return { ...this.payloadModel, enabled: true };
  }

  cleanPayloadModel(properties: Array<string>) {
    properties.forEach(property => {
      if (this.payloadModel[property])
        this.payloadModel[property] = parseFloat(this.payloadModel[property].toString().replace(/\$|,/g, ''));
      else delete this.payloadModel[property];
    });
  }
}
